import axios from "axios";

import { ImmunisationTypeTaskListModel, ImmunisationTypeTaskDetailModel, ImmunisationTypeTaskCreateModel, ImmunisationTypeTaskEditModel } from "./model";

class ImmunisationTypeTaskApi {

    private readonly apiBaseUrl = "/api/immunisationType";
    private readonly tasksApiSegment = "tasks";

    public async getAllByImmunisationTypeId(immunisationTypeId: string): Promise<ImmunisationTypeTaskListModel[]> {
        const response = await axios.get(`${this.apiBaseUrl}/${immunisationTypeId}/${this.tasksApiSegment}`);
        const data = response.data as ImmunisationTypeTaskListModel[];
        return data.map(this.parseModel);
    }

    public async getAllByCaseId(customerId: string, caseId: string): Promise<ImmunisationTypeTaskListModel[]> {
        const response = await axios.get(`/api/immunisationTypeTasks/${customerId}/${caseId}`);
        const data = response.data as ImmunisationTypeTaskListModel[];
        return data.map(this.parseModel);
    }

    public async getAllOfType(taskType: string): Promise<ImmunisationTypeTaskListModel[]> {
        const response = await axios.get(`/api/immunisationTypeTasks/${taskType}`);
        const data = response.data as ImmunisationTypeTaskListModel[];
        return data.map(this.parseModel);
    }

    public async detail(immunisationTypeId: string, id: any): Promise<ImmunisationTypeTaskDetailModel> {
        const response = await axios.get(`${this.apiBaseUrl}/${immunisationTypeId}/${this.tasksApiSegment}/${id}`);
        const model = response.data as ImmunisationTypeTaskDetailModel;
        return this.parseModel(model);
    }

    public async save(immunisationTypeTask: ImmunisationTypeTaskEditModel): Promise<ImmunisationTypeTaskDetailModel> {
        const response = await axios.put(
            `${this.apiBaseUrl}/${immunisationTypeTask.immunisationTypeId}/${this.tasksApiSegment}/${immunisationTypeTask.id}`,
            immunisationTypeTask);
        const model = response.data as ImmunisationTypeTaskDetailModel;
        return this.parseModel(model);
    }

    public async create(immunisationTypeTask: ImmunisationTypeTaskCreateModel): Promise<ImmunisationTypeTaskDetailModel> {
        const response = await axios.post(
            `${this.apiBaseUrl}/${immunisationTypeTask.immunisationTypeId}/${this.tasksApiSegment}`,
            immunisationTypeTask);
        const model = response.data as ImmunisationTypeTaskDetailModel;
        return this.parseModel(model);
    }

    public delete(immunisationTypeId: string, id: string): Promise<void> {
        return axios.delete(`${this.apiBaseUrl}/${immunisationTypeId}/${this.tasksApiSegment}/${id}`);
    }

    public parseModel(model: ImmunisationTypeTaskDetailModel): ImmunisationTypeTaskDetailModel {
        return {
            ...model
        };
    }
}

export const immunisationTypeTaskApi = new ImmunisationTypeTaskApi();
